import React from "react";
import { ListItemButton } from "@mui/material";
import { Link, useHref } from "react-router-dom";

interface ParentTourListItemButtonProps {
  parentId: number;
  children: React.ReactNode;
}

const ParentTourListItemButton: React.FC<ParentTourListItemButtonProps> = ({
  parentId,
  children,
}) => {
  const to = `/parent/${parentId}/`;
  const href = useHref(to);

  return (
    <ListItemButton
      component={Link}
      to={to}
      onClick={(e: React.MouseEvent) => {
        if (e.button === 0 && (e.ctrlKey || e.metaKey)) {
          e.preventDefault();
          window.open(href, "_blank", "noopener,noreferrer");
        }
      }}
    >
      {children}
    </ListItemButton>
  );
};

export default ParentTourListItemButton;
